import * as yup from 'yup';
var userValidation = yup.object().shape({
    fullName: yup.string().required(),
    email: yup.string().email().optional(),
});
export default userValidation;
